<script setup lang="ts">
import { useGlobalCounter } from '@/composables/useGlobalCounter';
import ToggleSwitch from 'primevue/toggleswitch';
import { useAttrs, type Ref } from 'vue';

defineOptions({
    // disable automatic attr inheritance: we do not want to pass attr to the root element,
    // but to the inner field instead
    inheritAttrs: false,
});

export type KpSelectFieldProps = {
    label?: string;
    inputId?: string;
    inputClass?: string | object;
};

const value: Ref<any> = defineModel();
const props = withDefaults(defineProps<KpSelectFieldProps>(), {
    inputId: () => useGlobalCounter('field'),
    inputClass: '',
});

const emit = defineEmits<{
    (e: 'change', value: any): void;
}>();

const slots = defineSlots<{
    [key: string]: (slotProps: any) => any;
}>();

const cls = useAttrs().class || null;
const fieldAttrs = { ...useAttrs() };
// Remove attributes for the inner field we do NOT want to pass along:
delete fieldAttrs.id;
delete fieldAttrs.class;

function onChange(value: any) {
    emit('change', value);
}
</script>

<template>
    <div :class="`field ${cls}`">
        <label v-if="label" :for="inputId" v-html="label"></label>
        <ToggleSwitch :id="inputId" v-model="value" :class="inputClass" v-bind="$attrs" @value-change="onChange" />
    </div>
</template>

<style lang="css" scoped>
.field {
    padding-inline: var(--p-inputtext-padding-x);
    label {
        display: block;
        padding-inline: 0;
    }
}
</style>
